import { render, staticRenderFns } from "./FPPagination.vue?vue&type=template&id=297ca3ae"
import script from "./FPPagination.vue?vue&type=script&lang=js"
export * from "./FPPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports